// Fonctions utilitaires pour les établissements
import { createMenuItem } from '@/components/Common/DropdownMenu/MenuDropdown.utils';

// Fonction helper pour mapper le type d'établissement
export const getEstablishmentTypeLabel = (type: string): string => {
  switch (type) {
    case 'PUBLIC':
      return 'Public';
    case 'PRIVATE':
      return 'Privé';
    default:
      return 'Non spécifié';
  }
};

// Fonction helper pour mapper le statut
export const getStatusLabel = (status: string): string => {
  switch (status) {
    case 'ACTIVE':
      return 'Activé';
    case 'INACTIVE':
      return 'En attente';
    default:
      return 'En attente';
  }
};

// Fonction pour déterminer si un établissement est actif
export const isEstablishmentActive = (status: string): boolean => {
  return status === 'ACTIVE';
};

// Re-export de createMenuItem pour faciliter l'utilisation
export { createMenuItem };
